import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircleBlue = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 21,
	viewBox: "0 0 19 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 9.6665,
		cy: 12,
		r: 8.55357,
		stroke: "#57B7AB",
		strokeWidth: .892857
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.75 11.4896L8.61458 14.3542L13.8229 9.14587",
		stroke: "#57B7AB",
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgCheckCircleBlue);
export { ForwardRef as ReactComponent };
